import React from 'react';
import styled, { useTheme } from 'styled-components/macro';
import { MdClose } from 'react-icons/md';

// style
import { Backdrop } from './style';

const VideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100vw - 60px);
  height: calc(100vw - 60px);
  max-width: 800px;
  max-height: 380px;
  position: relative;
`;

const Video = styled.video`
  background: black;
  height: 100%;
  width: 100%;
  object-fit: contain;
  max-height: 380px;
`;

const CloseButton = styled.div`
  position: absolute;
  z-index: 2;
  top: -25px;
  right: -25px;
  cursor: pointer;
  border: 2px solid ${props => props.theme.colors.white[100]};
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
`;

type Props = {
  videoSource: string;
  handleCloseModal: (e: any) => void;
};

export const ModalVideoCTA = ({ videoSource, handleCloseModal }: Props) => {
  const theme = useTheme();
  return (
    <Backdrop onClick={handleCloseModal}>
      <VideoWrapper onClick={(e: any) => e.stopPropagation()}>
        <CloseButton onClick={handleCloseModal}>
          <MdClose size={34} color={theme.colors.white[100]} />
        </CloseButton>
        <Video controls>
          <source src={videoSource} type='video/mp4' />
        </Video>
      </VideoWrapper>
    </Backdrop>
  );
};
